import {
	CLEAR_PRICES_AND_COSTS,
	SET_PRICES_AND_COSTS_APPLY,
	SET_PRICES_AND_COSTS_APPLY_SUCCESS,
	SET_PRICES_AND_COSTS_CALCULATE,
	SET_PRICES_AND_COSTS_CALCULATE_SUCCESS,
	SET_PRICES_AND_COSTS_CONFIRM,
	SET_PRICES_AND_COSTS_CONFIRM_SUCCESS,
	SET_PRICES_AND_COSTS_NEW_VALUE,
	SET_PRICES_AND_COSTS_NEW_VALUE_SUCCESS,
	SET_PRICES_AND_COSTS_PAGINATE,
	SET_PRICES_AND_COSTS_PAGINATE_SUCCESS,
	VERIFY_PRICES_AND_COSTS,
	VERIFY_PRICES_AND_COSTS_SUCCESS
} from 'constants/ActionsTypes'

export interface valueState {
	pricesAndCostsApplied: any
	pricesAndCostsCalculated: any
	pricesAndCostsConfirmed: any
	pricesAndCostsPagination: any
	pricesAndCostsVerified: any
	pricesAndCostsNewValued: any
}

const initialState = {
	pricesAndCostsApplied: null,
	pricesAndCostsCalculated: null,
	pricesAndCostsConfirmed: null,
	pricesAndCostsPagination: null,
	pricesAndCostsVerified: null,
	pricesAndCostsNewValued: null
}

function rootReducer(state: valueState = initialState, action: any) {
	switch (action.type) {
		case SET_PRICES_AND_COSTS_APPLY:
			return { ...state, pricesAndCostsApplied: null }
		case SET_PRICES_AND_COSTS_APPLY_SUCCESS:
			return { ...state, pricesAndCostsApplied: action.payload }
		case SET_PRICES_AND_COSTS_CALCULATE:
			return { ...state, pricesAndCostsCalculated: null }
		case SET_PRICES_AND_COSTS_CALCULATE_SUCCESS:
			return { ...state, pricesAndCostsCalculated: action.payload }
		case SET_PRICES_AND_COSTS_CONFIRM:
			return { ...state, pricesAndCostsConfirmed: null }
		case SET_PRICES_AND_COSTS_CONFIRM_SUCCESS:
			return { ...state, pricesAndCostsConfirmed: action.payload }
		case SET_PRICES_AND_COSTS_PAGINATE:
			return { ...state, pricesAndCostsPagination: null }
		case SET_PRICES_AND_COSTS_PAGINATE_SUCCESS:
			return { ...state, pricesAndCostsPagination: action.payload }
		case VERIFY_PRICES_AND_COSTS:
			return { ...state, pricesAndCostsVerified: null }
		case SET_PRICES_AND_COSTS_NEW_VALUE:
			return { ...state, pricesAndCostsNewValued: null }
		case SET_PRICES_AND_COSTS_NEW_VALUE_SUCCESS:
			return { ...state, pricesAndCostsNewValued: action.payload }
		case VERIFY_PRICES_AND_COSTS_SUCCESS:
			return { ...state, pricesAndCostsVerified: action.payload }
		case CLEAR_PRICES_AND_COSTS:
			return {
				...state,
				pricesAndCostsPagination: null,
				pricesAndCostsApplied: null,
				pricesAndCostsCalculated: null,
				pricesAndCostsNewValued: null,
				listProviders: null
			}
		default:
			return state
	}
}
export default rootReducer
